import React from 'react';
import { FONTS } from '../../styles/tokens';

interface UploadZoneProps {
  isDark: boolean;
  borderColor: string;
  textSecondary: string;
  inputRef: React.RefObject<HTMLInputElement | null>;
  onDrop: (e: React.DragEvent) => void;
  onSelect: (e: React.ChangeEvent<HTMLInputElement>) => void;
  /** Human-readable size cap, e.g. "Max 100MB". */
  sizeHint: string;
}

/**
 * Dashed-border zip-drop area with a hidden file input. Used by the deploy
 * chat to collect a project upload before the build pipeline kicks off.
 */
export function UploadZone(props: UploadZoneProps): React.JSX.Element {
  return (
    <div
      onDragOver={e => e.preventDefault()}
      onDrop={props.onDrop}
      onClick={() => props.inputRef.current?.click()}
      style={{
        margin: '12px 0',
        padding: '24px',
        borderRadius: '10px',
        border: `2px dashed ${props.borderColor}`,
        textAlign: 'center',
        backgroundColor: props.isDark ? 'rgba(1,169,237,0.05)' : 'rgba(1,169,237,0.08)',
        cursor: 'pointer',
        transition: 'border-color 0.2s',
      }}
    >
      <div style={{ fontFamily: FONTS.body, fontSize: '14px', color: props.textSecondary }}>
        Drag & drop your .zip file here, or click to browse
      </div>
      <div style={{ fontFamily: FONTS.body, fontSize: '11px', color: props.textSecondary, marginTop: '4px', opacity: 0.7 }}>
        {props.sizeHint}
      </div>
      <input
        ref={node => { (props.inputRef as React.MutableRefObject<HTMLInputElement | null>).current = node; }}
        type="file"
        accept=".zip"
        onChange={props.onSelect}
        style={{ display: 'none' }}
      />
    </div>
  );
}
